module.exports = __webpack_public_path__ + "fonts/icomoon.43c9fe2.ttf";